/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The list of available charge point models :
 * * EVLINK: EVLINK chargePoint by Schneider
 * * NBW30: NBw 30 chargePoint by Power Electronics
 * * KEYWATT24_STATION: Keywatt 24 Station chargepoint by IES
 * * C500: chargePoint by Kempower
 * * AXON_EASY: chargePoint by ekoenergetyka
 * * JEMA: chargePoint by IRIZAR
 */
export enum ChargePointModel {
  EVLINK = 'EVLINK',
  NBW30 = 'NBW30',
  KEYWATT24_STATION = 'KEYWATT24_STATION',
  C500 = 'C500',
  AXON_EASY = 'AXON_EASY',
  JEMA = 'JEMA'
}
